import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from './images/search.svg';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: 300,
    height: 54,
    background: '#fff',
    borderRadius: '3px !important',
    boxShadow: 'none',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    border: props => (props.withBorder ? '1px solid #E3E3E3' : 'none'),
  },
  input: {
    padding: props => (props.withSearch ? 0 : '0 10px'),
    flex: 1,
    color: theme.palette.text.primary,
  },
  iconButton: {
    padding: 16,
  },
}));

function MobileSearchBox({
  handleFocus,
  value,
  searchTopic,
  clickHandler,
  withBorder,
  withSearch,
}) {
  const classes = useStyles({ withBorder, withSearch });
  return (
    <Paper component="form" className={classes.root} onClick={clickHandler}>
      {withSearch && (
        <IconButton className={classes.iconButton} aria-label="Search">
          <img src={SearchIcon} alt="Search" />
        </IconButton>
      )}

      <InputBase
        className={classes.input}
        onFocus={handleFocus}
        onChange={searchTopic}
        placeholder="Help me with..."
        inputProps={{ 'aria-label': 'enter topics or categories' }}
        value={value}
      />
    </Paper>
  );
}

MobileSearchBox.propTypes = {
  handleFocus: PropTypes.func,
  value: PropTypes.string,
  searchTopic: PropTypes.func,
  clickHandler: PropTypes.func,
  withSearch: PropTypes.bool,
  withBorder: PropTypes.bool,
};

export default MobileSearchBox;
